import { useState } from "react";

const heroBg =
  "https://readdy.ai/api/search-image?query=wide%20panoramic%20warm%20toned%20stylized%20comic%20art%20collage%20of%20silhouetted%20characters%20and%20dynamic%20ink%20brush%20strokes%2C%20deep%20crimson%20amber%20and%20gold%20palette%2C%20dramatic%20gradient%20sky%2C%20artistic%20paper%20texture%2C%20cinematic%20atmosphere%2C%20no%20text&width=1800&height=1000&seq=jm-hero&orientation=landscape";

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    document.getElementById("quality")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative flex min-h-[92vh] items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={heroBg}
          alt="静漫天堂高清漫画静态图源氛围背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/70"></div>
      </div>

      <div className="relative mx-auto w-full max-w-5xl px-4 py-28 text-center md:px-6">
        <span className="mx-auto inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium tracking-wide text-background-50 backdrop-blur-sm">
          <i className="ri-sparkling-2-line text-accent-300"></i>
          高清原图 · 画质精选 · 持续上新
        </span>

        <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl md:leading-tight">
          静漫天堂漫画
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-50/85 md:text-lg">
          汇集高清原图与优质图源页面，按画质精细筛选，让每一位漫画爱好者都能快速找到清晰、纯净的静态漫画内容，重拾阅读的沉浸与感动。
        </p>

        <form
          onSubmit={handleSearch}
          className="mx-auto mt-9 flex max-w-xl items-center gap-2 rounded-full bg-background-50/95 p-2 shadow-[0_8px_30px_rgba(0,0,0,0.18)]"
        >
          <i className="ri-search-line pl-3 text-lg text-foreground-500"></i>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索作品、画质档位或分类…"
            aria-label="搜索漫画图源"
            className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
          />
          <button
            type="submit"
            className="shrink-0 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索图源
          </button>
        </form>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-2 text-xs text-background-50/80">
          <span className="text-background-50/60">热门：</span>
          {["4K超清", "古风原图", "分镜图源", "新作速递"].map((t) => (
            <button
              key={t}
              type="button"
              className="rounded-full border border-background-50/30 px-3 py-1 whitespace-nowrap transition-colors hover:border-accent-300 hover:text-accent-200"
            >
              {t}
            </button>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { n: "12,000+", d: "收录图源" },
            { n: "6 大类", d: "精细分类" },
            { n: "4K 原图", d: "画质保障" },
            { n: "24h", d: "持续上新" },
          ].map((s) => (
            <div
              key={s.d}
              className="rounded-2xl border border-background-50/15 bg-background-50/10 px-4 py-4 text-center backdrop-blur-sm"
            >
              <div className="font-heading text-2xl text-accent-300">{s.n}</div>
              <div className="mt-1 text-xs text-background-50/70">{s.d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}